module.exports = __webpack_public_path__ + "static/media/HN.8dc8c206.svg";